import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import { RootState } from "../../../../redux/store";
import { useSelector } from "react-redux";
import { styled } from "@mui/system";

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => {
  return <Tooltip {...props} classes={{ popper: className }} />;
})(() => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return {
    "& .MuiTooltip-tooltip": {
      color: colors?.surface.onSurface,
      backgroundColor: colors?.surface.surface,
      fontSize: "1rem",
      fontFamily: "inherit",
      whiteSpace: "pre-line",
      borderRadius: "0.8rem",
      padding: "1rem",
    },
  };
});

export const AppTooltip = (props: TooltipProps) => {
  return (
    <StyledTooltip {...props}>
      <div>{props.children}</div>
    </StyledTooltip>
  );
};
